<div class="analytics-container">

    <header class="page-header">
        <h2 class="page-title">Dashboard de Consumo</h2>
        <p class="page-subtitle">Monitoreo general del rendimiento filtrado por fecha, país y producto.</p>
    </header>

    <div class="clean-card filters-section">
        <div class="section-header">
            <h3>Search Filters</h3>
        </div>

        <div class="filters-grid" [formGroup]="filterForm">
            <div class="filter-group">
                <div class="pl-2 font-black">Cliente</div>
                <div class="select-wrapper">
                    <select formControlName="client">
                        <option value="" disabled selected>Seleccionar cliente</option>
                        <option *ngFor="let client of clientsList" [value]="client.id">
                            {{ client.name }}
                        </option>
                    </select>
                    <mat-icon class="chevron">expand_more</mat-icon>
                </div>
            </div>

            <div class="filter-group">
                <div class="pl-2 font-black">Categoría</div>
                <div class="select-wrapper">
                    <select formControlName="category">
                        <option value="" selected>Todas</option>
                        <option *ngFor="let cat of filteredCategories" [value]="cat.id">
                            {{ cat.name }}
                        </option>
                    </select>
                    <mat-icon class="chevron">expand_more</mat-icon>
                </div>
            </div>

            <div class="filter-group">
                <div class="pl-2 font-black">Subcategoría</div>
                <div class="select-wrapper">
                    <select formControlName="subcategory">
                        <option value="" selected>Todas</option>
                        <option *ngFor="let sub of filteredSubcategories" [value]="sub.id">
                            {{ sub.name }}
                        </option>
                    </select>
                    <mat-icon class="chevron">expand_more</mat-icon>
                </div>
            </div>

            <div class="filter-group">
                <div class="pl-2 font-black">País</div>
                <div class="select-wrapper">
                    <select formControlName="country">
                        <option value="" selected>Todos</option>
                        <option *ngFor="let country of countriesList" [value]="country.id">
                            {{ country.name }}
                        </option>
                    </select>
                    <mat-icon class="chevron">expand_more</mat-icon>
                </div>
            </div>

            <div class="filter-group">
                <div class="pl-2 font-black">Producto</div>
                <div class="select-wrapper">
                    <select formControlName="product">
                        <option value="" selected>Todos</option>
                        <option *ngFor="let prod of filteredProducts" [value]="prod.id">
                            {{ prod.name }}
                        </option>
                    </select>
                    <mat-icon class="chevron">expand_more</mat-icon>
                </div>
            </div>

            <div class="filter-group filter-group--date-range">
                <div class="pl-2 font-black">Rango de fechas</div>
                <p-calendar
                    placeholder="Selecciona un rango"
                    formControlName="rangeDate"
                    selectionMode="range"
                    dateFormat="yy-mm-dd"
                    [showIcon]="true"
                    [readonlyInput]="true"
                ></p-calendar>
            </div>
        </div>

        <div class="filters-footer-wrap">
            <div class="filters-footer">
                <button type="button" class="btn-download" (click)="downloadGeneralReport()"
                    [disabled]="isDownloadingReport">
                    <mat-icon>schedule_send</mat-icon>
                    <span *ngIf="!isDownloadingReport">Solicitar Reporte Excel</span>
                    <span *ngIf="isDownloadingReport">Enviando solicitud...</span>
                </button>
                <button type="button" class="btn-primary" (click)="onSearch()"
                    [disabled]="isLoadingMetrics">
                    <span *ngIf="!isLoadingMetrics">Buscar</span>
                    <span *ngIf="isLoadingMetrics">Cargando...</span>
                </button>
            </div>
            <p class="filters-footer-alert" *ngIf="filtersFooterAlert"
                role="alert" aria-live="polite">
                {{ filtersFooterAlert }}
            </p>
        </div>
    </div>

    <div class="charts-grid">

        <div class="clean-card dashboard-card">
            <div class="card-header">
                <span class="card-title">SOLICITUDES CORRECTAS</span>
            </div>

            <div class="big-number">{{ successTotal | number }}</div>

            <div class="chart-container">
                <svg viewBox="0 0 400 150" class="chart-svg" preserveAspectRatio="none">
                    <defs>
                        <linearGradient id="gradientSuccess" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="0%" stop-color="#2D7A6B" stop-opacity="0.2" />
                            <stop offset="100%" stop-color="#2D7A6B" stop-opacity="0" />
                        </linearGradient>
                    </defs>

                    <line *ngFor="let y of [0, 37.5, 75, 112.5, 150]" x1="0" [attr.y1]="y" x2="400" [attr.y2]="y"
                        stroke="#E2E8F0" stroke-width="1" stroke-dasharray="4 4" />

                    <line *ngFor="let p of successPoints" [attr.x1]="p.x" y1="150" [attr.x2]="p.x" y2="155"
                        stroke="#E2E8F0" stroke-width="1" />

                    <path [attr.d]="successPathArea" fill="url(#gradientSuccess)" />

                    <path [attr.d]="successPathLine" fill="none" stroke="#2D7A6B" stroke-width="3"
                        stroke-linecap="round" vector-effect="non-scaling-stroke" />

                    <g *ngFor="let p of successPoints" class="point-group">

                        <circle [attr.cx]="p.x" [attr.cy]="p.y" r="12" fill="transparent" style="cursor: pointer;" />

                        <circle [attr.cx]="p.x" [attr.cy]="p.y" r="4" fill="white" stroke="#2D7A6B" stroke-width="2"
                            class="visible-point" />

                        <g class="tooltip" [attr.transform]="'translate(' + p.x + ',' + (p.y - 20) + ')'">
                            <rect x="-35" y="-35" width="70" height="30" rx="4" fill="#2F424A" opacity="0.9" />
                            <path d="M-5,-5 L0,0 L5,-5 Z" fill="#2F424A" opacity="0.9" />

                            <text x="0" y="-20" text-anchor="middle" fill="white" font-size="10px" font-weight="600">
                                {{ p.val | number }}
                            </text>
                            <text x="0" y="-10" text-anchor="middle" fill="#CBD5E0" font-size="8px">
                                {{ p.dateLabel }}
                            </text>
                        </g>
                    </g>
                </svg>

                <div class="chart-labels">
                    <span *ngFor="let lbl of successLabels">{{ lbl }}</span>
                </div>
            </div>

            <div class="card-footer">
                <button class="link-btn">
                    <mat-icon>download</mat-icon> Descargar Reporte
                </button>
            </div>
        </div>

        <div class="clean-card dashboard-card">
            <div class="card-header">
                <span class="card-title">SOLICITUDES FALLIDAS</span>
            </div>

            <div class="big-number">{{ errorTotal | number }}</div>

            <div class="legend">
                <div class="item">
                    <div class="dot dark"></div> <span>Err 400</span>
                </div>
                <div class="item">
                    <div class="dot orange"></div> <span>Err 500</span>
                </div>
            </div>

            <div class="chart-container">
                <svg viewBox="0 0 400 150" class="chart-svg" preserveAspectRatio="none">
                    <line *ngFor="let y of [0, 37.5, 75, 112.5, 150]" x1="0" [attr.y1]="y" x2="400" [attr.y2]="y"
                        stroke="#E2E8F0" stroke-width="1" />

                    <line *ngFor="let bar of errorBars" [attr.x1]="bar.x + 9" y1="150" [attr.x2]="bar.x + 9" y2="155"
                        stroke="#E2E8F0" stroke-width="1" />

                    <g *ngFor="let bar of errorBars" class="bar-group">

                        <rect [attr.x]="bar.x" [attr.y]="bar.y400" width="8" [attr.height]="bar.h400" fill="#2F424A"
                            rx="2" class="bar-rect" />
                        <rect [attr.x]="bar.x + 10" [attr.y]="bar.y500" width="8" [attr.height]="bar.h500"
                            fill="#9F633A" rx="2" class="bar-rect" />

                        <rect [attr.x]="bar.x - 5" y="0" width="28" height="150" fill="transparent"
                            style="cursor: pointer;" />

                        <g class="tooltip"
                            [attr.transform]="'translate(' + (bar.x + 9) + ',' + (Math.min(bar.y400, bar.y500) - 10) + ')'">
                            <rect x="-45" y="-55" width="90" height="50" rx="4" fill="white" stroke="#E2E8F0"
                                stroke-width="1" />

                            <text x="0" y="-40" text-anchor="middle" font-size="10px" fill="#2F424A"
                                font-weight="bold">{{ bar.fullDate }}</text>

                            <circle cx="-25" cy="-25" r="3" fill="#2F424A" />
                            <text x="-18" y="-22" font-size="10px" fill="#687782">400: <tspan fill="#2F424A"
                                    font-weight="bold">{{ bar.raw400 }}</tspan></text>

                            <circle cx="-25" cy="-10" r="3" fill="#9F633A" />
                            <text x="-18" y="-7" font-size="10px" fill="#687782">500: <tspan fill="#2F424A"
                                    font-weight="bold">{{ bar.raw500 }}</tspan></text>
                        </g>
                    </g>
                </svg>

                <div class="chart-labels justified">
                    <span *ngFor="let bar of errorBars; let i = index"
                        [style.visibility]="i % 2 === 0 ? 'visible' : 'hidden'">
                        {{ bar.label }}
                    </span>
                </div>
            </div>

            <div class="card-footer">
                <button class="link-btn">
                    <mat-icon>download</mat-icon> Descargar Reporte
                </button>
            </div>
        </div>

    </div>
</div>